import { css } from '@emotion/css'
import { fontSize, spacing, borderRadius, fontFamily, shorthandHelper, colors, hexToRgba } from '@offerzen/pinata'

const styles = {
  wrapper: css({
    marginRight: spacing.small,
    display: 'flex',
    alignItems: 'center',
    fontSize: fontSize.small,
    lineHeight: 1.2,
    backgroundColor: colors.blueZodiac,
    color: colors.white,
    border: `1px solid ${colors.blueZodiac}`,
    borderRadius: borderRadius.extraLarge,
    fontFamily: fontFamily.body,
    padding: shorthandHelper([0, spacing.extraSmall, 0, spacing.default]),
    flex: 'none',
    position: 'relative',
    height: 20,
  }),

  notVisibleWrapper: css({
    '&:hover': {
      borderColor: hexToRgba(colors.froly, 1),
    },
  }),

  visibleWrapper: css({
    '&:hover': {
      borderColor: hexToRgba(colors.cornflowerBlue, 1),
    },
  }),

  question: css({
    marginLeft: spacing.small,
    backgroundColor: colors.white,
    borderRadius: borderRadius.extraLarge,
  }),

  notVisibleText: css({
    color: colors.froly,
    padding: spacing.extraSmall,
  }),

  visibleText: css({
    color: colors.cornflowerBlue,
    padding: spacing.extraSmall,
  }),

  content: css({
    position: 'absolute',
    width: 270,
    top: 10,
    right: -24,
    padding: 10, // carat is 10px
  }),

  contentText: css({
    backgroundColor: colors.white,
    color: colors.blueZodiac,
    padding: 10,
    borderRadius: borderRadius.default,
    boxShadow: `0 0 4px 2px ${hexToRgba(colors.scorpion, 0.1)}`,
  }),

  carat: css({
    position: 'absolute',
    right: 16,
    top: 0,
  }),
}

export default styles
